'use client';

var EMPTY_COMPANY_IMAGE = 'https://images.vietnamworks.com/img/company-default-logo.svg';

export { EMPTY_COMPANY_IMAGE };
//# sourceMappingURL=constants.js.map
